/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
const ConstUmatiColors = {
  Primary: '#1d9dd9',
  Secondary: '#e30d7d',
  Light: '#eaeaea',
  Success: '#00b20e',
  Info: '#17a2b8',
  Warning: '#ffc107',
  Danger: '#ff4136',
  Dark: '#343a40',
};

export default ConstUmatiColors;
